import { FC, ReactNode, useState } from "react";
import { Flex, LegacyCard, Modal } from "@payping/web-components";

interface Props {
  title: ReactNode;
  icon: ReactNode;
  modalIcon: ReactNode;
  modalDescription: ReactNode;
  [name: `data-${string}`]: string | undefined;
}
export const CapabilityLayout: FC<Props> = ({ title, icon, modalIcon, modalDescription, ...dataAttributes }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <LegacyCard.Ant className="tw:cursor-pointer" cover={icon} onClick={() => setOpenModal(true)} {...dataAttributes}>
        {title}
      </LegacyCard.Ant>

      <Modal
        open={openModal}
        title={title}
        closable
        onCancel={() => setOpenModal(false)}
        mask={{ closable: false }}
        footer={null}
      >
        <Flex vertical gap={16}>
          {modalIcon}
          {modalDescription}
        </Flex>
      </Modal>
    </>
  );
};
